import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateNodesFromDOM } from '@lexical/html';
import { $getRoot } from 'lexical';
import { $wrapTopLevelInlines } from '@/components/LexicalEditor/utils/wrapTopLevelInlines';

export type ReplaceContentApi = {
  /** 본문 전체를 HTML 로 교체. 한 번의 update 라 되돌리기(Ctrl+Z)로 복구 가능 */
  replace: (html: string) => void;
};

type ReplaceContentPluginProps = {
  /** mount 때 API, unmount 때 null */
  onApiChange: (api: ReplaceContentApi | null) => void;
};

/** 양식 선택 등으로 작성 중 본문을 통째로 갈아끼우는 플러그인 */
const ReplaceContentPlugin = ({ onApiChange }: ReplaceContentPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    onApiChange({
      replace: (html) => {
        editor.update(() => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const root = $getRoot();
          root.clear();
          // root 직접 append 경로 — 최상위 인라인은 #282 회피용 문단 감싸기 필수
          root.append(
            ...$wrapTopLevelInlines($generateNodesFromDOM(editor, doc)),
          );
        });
      },
    });
    return () => onApiChange(null);
  }, [editor, onApiChange]);

  return null;
};

export default ReplaceContentPlugin;
